import React, { Component } from 'react';
import { BrowserRouter as Router, Route } from 'react-router-dom';

import './App.css';

import Attendance from './components/Attendance';
import NCAA from './components/NCAA';
import NCAAChamps from './components/NCAAChamps';
import NationalTeams from './components/NationalTeams';
import TeamsMap from './components/TeamsMap';
import CoachesPoll from './components/CoachesPoll';
import AllTeams from './components/AllTeams';

import NavBoxes from './components/nav/NavBoxes';

class App extends Component {
  constructor(props) {
      super(props);
      this.state = {
        meets: []
      };
  }
  render() {
    return (
      <div className="App">
        <Router basename="/results/chartsM">
          <div>
            <Route path='/' render={(props) => (
                <NavBoxes {...props} />
            )} />
            <div className="row expanded">
              <div className="small-12 columns small-collapse small-no-spacing">
                  <Route exact path="/" component={Attendance}/>
                  <Route path="/ncaa" component={NCAA}/>
                  <Route path="/ncaachamps" component={NCAAChamps}/>
                  <Route path="/nationalteams" component={NationalTeams}/>
                  <Route path="/teamsmap" component={TeamsMap}/>
                  <Route path="/coachespoll" component={CoachesPoll}/>
                  <Route path="/allteams" component={AllTeams}/>
              </div>
            </div>
         </div>
        </Router>
      </div>
    );
  }
}

export default App;



// WEBPACK FOOTER //
// ./src/App.js